import styled from '@emotion/styled'
import React from 'react'
import { useIntl } from 'react-intl'
import { H3 } from '../../../../layouts/TextStyles'
import SubjectProgressCard from './components/SubjectProgressCard'

const CourseProgressPage = () => {
    const { formatMessage } = useIntl()

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'subjects' })}</H3>
                    </Title>
                </Header>

                {/* {isFetching && <LinearProgress />} */}
                <SubjectProgressCard />
                <SubjectProgressCard />
                <SubjectProgressCard />
                <SubjectProgressCard />
            </Content>
        </Wrapper>
    )
}

export default CourseProgressPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
